import { Box, Link, Text, useColorMode, VStack } from "@chakra-ui/react";
import React from 'react';
import metadata from '../../metadata.json';

function Footer() {
    const { colorMode } = useColorMode();
    const isDark = colorMode === "dark";
    return (
        <VStack spacing={0}>
        {/* <Flex rounded="xl"> */}
        <Box bg={isDark ? "gray.800" : "white"}
        w="100%" zIndex={2} textAlign="center">
            <Text textAlign="center" fontSize="md"
                m="1" >Made with ❤️  &nbsp; by &nbsp;
                <Link color="teal.500" isExternal href="https://virtuosars.github.io/ARSOnePage/">
                    Ankush Sankhe 
                </Link>
                &nbsp; - v{metadata.buildMajor}.{metadata.buildMinor}.{metadata.buildRevision}
            </Text>
        </Box>
        <Box bg={isDark ? "gray.800" : "white"}
        w="100%" zIndex={2} textAlign="center">
        <Text textAlign="center" fontSize="md"
                m="1" >Inspiration from &nbsp;
        <Link color="teal.500" isExternal href="https://scripbox.com/plan/power-of-compounding">
            Scripbox
        </Link>
        </Text>
        </Box>
        {/* </Flex> */}
        </VStack>
    )
}

export default Footer
